import { Route, Routes, BrowserRouter } from "react-router-dom"
import Layout from "./Layout"; 
import Analyzer from "./routes/Analyzer"
import Home from "./routes/home"
import Profile from "./routes/profile";
import DBoard from "./routes/dashboard";
import Cancref from "./routes/cancref";
import Contact from "./routes/contact";
import Privacy  from "./routes/privacy";
import Tc from "./routes/tc";
import Shipping from "./routes/shipping";
import { SignedIn, SignedOut,RedirectToSignIn} from '@clerk/clerk-react';
import { Analytics } from "@vercel/analytics/react"

export default function App(){
  return(
    <>
      <Analytics />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<Privacy />} />
            <Route path="terms" element={<Tc />} />
            <Route path="refund-policy" element={<Cancref />} />
            <Route path="shipping-policy" element={<Shipping />} />
            <Route path="contact" element={<Contact />} />
            <Route
              path="analyzer"
              element={
                <>
                  <SignedIn>
                    <Analyzer />
                  </SignedIn>
                  <SignedOut>
                    <RedirectToSignIn />
                  </SignedOut>
                </>
              }
            />
            <Route
              path="profile"
              element={
                <>
                  <SignedIn>
                    <Profile />
                  </SignedIn>
                  <SignedOut>
                    <RedirectToSignIn />
                  </SignedOut>
                </>
              }
            />
            <Route path="dashboard" element={<DBoard />} />
            </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}